export default "__VITE_ASSET__9cuDuyb0__"